import { render } from 'solid-js/web';
import 'solid-devtools';
import { Renderer } from 'framework';
import { log } from '@luma.gl/core';

import '../style/index.css';
import { version } from '../../../package.json';

declare const LUMAGL_DEBUG: boolean;
if (typeof LUMAGL_DEBUG !== 'undefined' && LUMAGL_DEBUG) {
  log.enable();
  log.level = 2;
} else {
  log.level = 0;
}

const root = document.querySelector('#eidos');
const params = new URLSearchParams(window.location.search);
const id = params.get('id');

console.log('Eidos version ', version);

render(
  () => <Renderer id={id} onContextMenu={(e) => e.preventDefault()} />,
  root,
);
